/** Copy of the `/contact-us` heading (`ContactUsPage.Components.tsx` → `ContactUsTitle`). */
import { LanguageContent } from "@ryerson/frontend.common";
import { ContactUsPageProps } from "./ContactUsPage.Models";

/** The heading copy by language. `metalExperts` isn't rendered anywhere. */
export const content: LanguageContent<ContactUsPageProps> = {
    en: {
        header: "Contact Us",
        subHeader: "Call or text us at: ",
        metalExperts: "Your Metals Professional",
    },
    fr: {
        header: "Communiquer avec nous",
        subHeader: "Appelez-nous ou envoyez-nous un texto au numéro suivant: ",
        metalExperts: "Votre expert en métaux",
    },
    es: {
        header: "Contáctenos",
        subHeader: "Llámenos o envíenos un mensaje de texto a: ",
        metalExperts: "Tu experto en metales",
    },
};